import { render, staticRenderFns } from "./PgtoNegado.vue?vue&type=template&id=e744aca4&scoped=true&"
import script from "./PgtoNegado.vue?vue&type=script&lang=js&"
export * from "./PgtoNegado.vue?vue&type=script&lang=js&"
import style0 from "./PgtoNegado.vue?vue&type=style&index=0&id=e744aca4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e744aca4",
  null
  
)

export default component.exports